import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';

import SalesByCategoryGraph from '../SalesByCategory/Components/SalesByCategory.Graph';
import CategoryInsights from './Components/CategoryInsights/CategoryInsights';
import SalesByCustomCollectionGraph from '../SalesByCustomCollection/Components/SalesByCustomCollectionGraph/SalesByCustomCollection.Graph';
import ChevronDown from '../../Assets/Dropdown/ChevronDown.svg';

function SalesByCategoryStats() {
    const location = useLocation();

    const [graphData, setGraphData] = useState([]);

    useEffect(() => {
        setGraphData(location.state.graphData);
    }, [location]);

    return (
        <div className="w-full overflow-y-scroll pb-16">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to={`${location.pathname.split('/').slice(0, -1).join('/')}`} className="img p-[10px] flex items-center justify-center">
                        <img className='w-6 h-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-bold text-2xl">{location.pathname.split('/').reverse()[1] ===  'sales-by-category' ? 'Sales by Category' : 'Sales by custom collection'}</h1>
                </div>

                <button onClick={() => {}} className="cursor-pointer rounded-md border border-[#EAEAEA] p-[10px_2px_10px_8px] flex items-center gap-1">
                    <p className='w-20 font-semibold text-[14px] leading-[22px] text-[#121212] text-left whitespace-nowrap'>Last 30 days</p>

                    <div className="size-[22px] flex items-center justify-center">
                        <img src={ChevronDown} alt="" />
                    </div>
                </button>
            </div>

            <div className="flex mt-3 mx-5">
                {location.pathname.split('/').reverse()[1] ===  'sales-by-category' ? 
                    <SalesByCategoryGraph 
                        active={location.state.category} 
                        salesByCategoryData={graphData} 
                        colorsList={location.state.colorsList} 
                    /> : 
                    <SalesByCustomCollectionGraph 
                        active={location.state.category} 
                        salesByCustomCollectionData={graphData} 
                        colorsList={location.state.colorsList} 
                    />
                }
            </div>

            {/* Clothing Insights */}
            <CategoryInsights 
                categoryData={
                    {
                        name: location.state.category,
                        data: {
                            // Some data for the category
                        }
                    }
                }
            />
        </div>
    )
}

export default SalesByCategoryStats;
